import React from 'react'
import { Grid, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';

let propName = '';
let propValue = {};
let optionsArray = [];
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})
class PracticeFlowResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            option: 'raci',
            isDisabled: true
        }
        this.createRaciObject = this.createRaciObject.bind(this);
        this.changeManagerA = this.changeManagerA.bind(this);
        this.deleteC = this.deleteC.bind(this);
        this.deleteI = this.deleteI.bind(this);
        this.deleteR = this.deleteR.bind(this);
        this.changeManager = this.changeManager.bind(this);
    }
    componentWillMount() {

        this.createOptionsArray();

    }

    createOptionsArray() {
        let initiativeData;
        if (this.props.activeTab === "myactivities") {
            initiativeData = this.props.selectedActivityData.initiativeId;
        } else {
            initiativeData = this.props.selectedDataById;
        }
        optionsArray = [];
        if (initiativeData.communities) {
            initiativeData.communities.map((community) => {
                if (community.communities) {
                    community.communities.map((subCommunity) => {

                        if (!this.props.selectedActivityData.raci ||
                            (propName === 'a' && this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.a && this.props.selectedActivityData.raci.a.communityId !== subCommunity._id) ||
                            ((propName === 'r' && (!this.props.selectedActivityData.raci.r || this.props.selectedActivityData.raci.r.findIndex(x => x.communityId === subCommunity._id) === -1)) ||
                                (propName === 'c' && (!this.props.selectedActivityData.raci.c || this.props.selectedActivityData.raci.c.findIndex(x => x.communityId === subCommunity._id) === -1)) ||
                                (propName === 'i' && (!this.props.selectedActivityData.raci.i || this.props.selectedActivityData.raci.i.findIndex(x => x.communityId === subCommunity._id) === -1)))
                        ) {
                            optionsArray.push({ id: subCommunity._id, label: community.name + " > " + subCommunity.name, associatedTeamId: subCommunity.associatedTeam });
                            dispatch.initiatives.getManagersBySuborgId(subCommunity.associatedTeam)
                            if (optionsArray.length === 0) {
                                propValue = {};
                                this.setState({ 'isDisabled': true })
                            }
                        } else {
                            if (optionsArray.length === 0) {
                                propValue = {};
                                this.setState({ 'isDisabled': true })
                            }
                        }

                    }, this)
                }

            }, this);
        }
    }
    createRaciObject(data) {
        this.setState({ 'isDisabled': true })
        switch (data.target.name) {
            case 'raci': propName = data.target.value ? data.target.value : '';
                this.setState({ option: data.target.value });
                propValue.accountUserId = null
                if (propValue.communityId && this.props.RaciUserList && this.props.RaciUserList.data && propValue && propValue.accountUserId) {
                    this.setState({ 'isDisabled': false })
                }
                else {
                    this.setState({ 'isDisabled': true })
                }

                this.createOptionsArray();
                break;
            case 'assignment': propValue = data.target.value ? data.target.value : '';
        }
        if (data.target.name === 'assignment') {
            if (data.target.value === 'Select') {
                propValue = {};
                this.setState({ 'isDisabled': true })
            }
            else {
                let value = JSON.parse(data.target.value);
                propValue = { 'communityId': value.id, 'teamId': value.associatedTeamId };
                this.setState({ 'isDisabled': true })
                dispatch.initiatives.getManagersBySuborgId(value.associatedTeamId)
            }
        }



    }
    resetDropDown() {
        this.setState({ option: 'raci' })
    }
    addRaciToActivity(formData, resetForm) {
        this.setState({ isDisabled: false });


        if ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i') && (propValue && propValue !== 'Select')) {
            if (!propValue.accountUserId) {
                propValue.accountUserId = this.props.RaciUserList.data[0]._id
            }
            if (!this.props.selectedActivityData.raci) {
                this.props.selectedActivityData.raci = {};
            }
            if (propName === 'a') {
                if (this.props.selectedActivityData.raci.a && this.props.selectedActivityData.raci.a.communityId) {
                    this.props.selectedActivityData.raci.a.communityId = propValue.communityId;
                    this.props.selectedActivityData.raci.a.accountUserId = propValue.accountUserId;
                    this.props.selectedActivityData.raci.a.teamId = propValue.teamId;
                    this.deleteFromActivityActions(propName, this.props.selectedActivityData.raci[propName].communityId);
                }
                else {
                    this.props.selectedActivityData.raci.a = {};
                    this.props.selectedActivityData.raci.a.communityId = propValue.communityId;
                    this.props.selectedActivityData.raci.a.accountUserId = propValue.accountUserId;
                    this.props.selectedActivityData.raci.a.teamId = propValue.teamId;
                }
                this.props.selectedActivityData.raci.a.changedMapping = true
                this.props.selectedActivityData.raci.a.changedAssignee = true
                dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
            }
            else {
                if (!this.props.selectedActivityData.raci[propName])
                    this.props.selectedActivityData.raci[propName] = [];
                this.props.selectedActivityData.raci[propName].push(propValue);

            }
            let actionObject = {};
            actionObject[propName] = propValue.communityId;
            dispatch.initiatives.updateActivityAction(actionObject);
            dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
            propValue = {}
            optionsArray = [];
            this.props.RaciUserList.data = [];
            this.setState({ 'isDisabled': true })
        }

        else {
            toastr.error('Message', 'Please select options from dropdown.');
        }
        this.resetDropDown();

    }
    getMapping(id) {
        let mappingData;
        if (this.props.activeTab === 'myactivities') {
            mappingData = this.props.selectedActivityData.initiativeId;

        }
        else {
            mappingData = this.props.selectedDataById;
        }
        if (mappingData.communities)
            for (let i = 0; i < mappingData.communities.length; i++) {
                let community = mappingData.communities[i];
                if (id === community._id) {
                    return community.name;
                }
                if (community.communities)
                    for (let j = 0; j < community.communities.length; j++) {
                        let subCommunity = community.communities[j];
                        if (id === subCommunity._id) {
                            return community.name + " > " + subCommunity.name;
                        }
                    }
            }
    }

    resetForm() {
        document.getElementById("raciForm").reset();
    }
    changeManager(data) {
        this.setState({ 'isDisabled': true });
        if ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i') && (data.target.value !== 'raci') && (propValue && propValue !== 'Select' && propValue.communityId)) {
            propValue.accountUserId = data.target.value;
            this.setState({ 'isDisabled': false })
        }
    }
    changeManagerA(data) {
        this.props.selectedActivityData.raci.a.accountUserId = data.target.value;
        this.props.selectedActivityData.raci.a.changedMapping = true;
        this.props.selectedActivityData.raci.a.changedAssignee = true;
        dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
    }
    deleteC(cObj) {

        let index = this.props.selectedActivityData.raci.c.filter((c) => {
            return c.communityId === cObj.communityId
        })

        let Cindex = this.props.selectedActivityData.raci.c.indexOf(index[0]);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to remove this Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index) {
                    this.props.selectedActivityData.raci.c.splice(Cindex, 1);
                    this.forceUpdate();
                    this.deleteFromActivityActions('c', cObj.communityId);
                    dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                }
            }
        });
    }
    deleteI(iObj) {
        let index = this.props.selectedActivityData.raci.i.filter((i) => {
            return i.communityId === iObj.communityId
        })
        let Iindex = this.props.selectedActivityData.raci.i.indexOf(index[0]);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to remove this Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index) {
                    this.props.selectedActivityData.raci.i.splice(Iindex, 1);
                    this.forceUpdate();
                    this.deleteFromActivityActions('i', iObj.communityId);
                    dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                }
            }
        });
    }
    deleteR(rObj) {
        if (this.props.selectedActivityData.raci.r.length > 1) {
            let index = this.props.selectedActivityData.raci.r.filter((r) => {
                return r.communityId === rObj.communityId
            })
            let Rindex = this.props.selectedActivityData.raci.r.indexOf(index[0]);
            let message = <div className="confirmMessage">
                <h3>Delete Role</h3>
                <p>Are you sure that you wish to remove this Role?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: () => {
                    if (index) {
                        this.props.selectedActivityData.raci.r.splice(Rindex, 1);
                        this.forceUpdate();
                        this.deleteFromActivityActions('r', rObj.communityId);
                        dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                    }
                }
            });
        }
        else {
            toastr.error('Message', 'There should be atleast one R.');
        }
    }
    deleteFromActivityActions(propertyName, id) {
        if (this.props.activityActions) {
            let indexInActions = (() => {
                for (let i = 0; i < this.props.activityActions.length; i++) {
                    if (this.props.activityActions[i][propertyName] && this.props.activityActions[i][propertyName] === id && !this.props.activityActions[i].deleted) {
                        return i;
                    }

                }
                return -1;
            })();
            if (indexInActions !== -1) {
                dispatch.initiatives.removeFromActivityAction(indexInActions);
            } else {

                let actionObject = {};
                actionObject[propertyName] = id;
                actionObject.deleted = true;
                dispatch.initiatives.updateActivityAction(actionObject);
            }
        }

    }

    render() {
        let initiativeCreatedBy = "";
        let initiativeData;
        if (this.props.activeTab === "myactivities") {
            initiativeCreatedBy = this.props.selectedActivityData.initiativeId.createdBy
            initiativeData = this.props.selectedActivityData.initiativeId;
        } else {
            initiativeCreatedBy = this.props.selectedDataById.createdBy
            initiativeData = this.props.selectedDataById;
        }

        const showA = () => {

            if (this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.a) {
                let accountableUser = this.props.selectedActivityData.raci.a.userList && this.props.selectedActivityData.raci.a.userList.length > 0 && this.props.selectedActivityData.raci.a.userList.find(user => {
                    return user.accountUserId._id.toString() === this.props.selectedActivityData.raci.a.accountUserId.toString()
                })
                return (
                    <Grid.Row className=" pad_0  " >
                        <Grid.Column width={3}>
                            <div className="divBlock">
                                <EllipsisTooltip name="Accountable" />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={7}>
                            <div className="divBlock">
                                {this.getMapping(this.props.selectedActivityData.raci.a.communityId)}
                            </div>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            { !enableForm && accountableUser
                                    ?
                                    <div className="divBlock">
                                        {accountableUser && accountableUser.accountUserId ?
                                            <span>
                                                {accountableUser.accountUserId.firstName + ' ' + accountableUser.accountUserId.lastName + ' '}
                                                <span style={{marginLeft:"5px"}}>{'(' + accountableUser.accountUserId.email + ')'}</span>
                                            </span> : null}

                                    </div>
                                    :
                                    <Form.Field
                                        className="defaultSelect users-list"
                                        placeholder="Select User"
                                        name='user'
                                        id='user'
                                        required
                                        value={this.props.selectedActivityData.raci.a.accountUserId}
                                        onChange={this.changeManagerA}
                                        control='select'
                                    >
                                        {this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.a && this.props.selectedActivityData.raci.a.userList ?
                                            this.props.selectedActivityData.raci.a.userList.map((user) => {
                                                return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName} { '(' + user.accountUserId.email + ')'} </option>
                                            }) :
                                            this.props.RaciUserList && this.props.RaciUserList.data ?
                                                this.props.RaciUserList.data.map((user) => {
                                                    return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName} { '(' + user.accountUserId.email + ')'}</option>
                                                }) :
                                                <option value='raci'>Select User</option>
                                        }
                                    </Form.Field>
                            }
                        </Grid.Column>
                    </Grid.Row>
                )
            }
        }

        let enableForm = initiativeData.status !== 3 &&
         this.props.selectedActivityData.runStatus !== 2 && 
        (this.props.selectedOrganisation.role === "workspaceOwner" ||
            ((initiativeCreatedBy === this.props.user._id)
            || (this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.a.accountUserId === this.props.user._id))
         )
        

        // ((initiativeCreatedBy !== this.props.user._id)
        //                     && (this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.a.accountUserId !== this.props.user._id))
       
        const showForm = () => {
            return (
                <Form noValidate
                    name='raciForm'
                    className="formcyForm pad_0 "
                    id='raciForm'
                    ref={ref => this.form = ref}
                    onValidSubmit={(formData) => { this.addRaciToActivity(formData) }}
                >
                    <Grid.Row width={16}>
                        {enableForm ? 
                            <Form.Group inline >
                                <Grid.Column width={3} >

                                    <Form.Field
                                        placeholder="RACI"
                                        name='raci'
                                        id='raci'
                                        required
                                        onChange={this.createRaciObject}
                                        control='select'
                                        style={{ 'width': '100%' }}
                                        value={this.state.option}
                                    >

                                        <option value='raci'>RACI</option>
                                        <option value='r'>Responsible</option>
                                        <option value='a'>Accountable</option>
                                        <option value='c'>Consulted</option>
                                        <option value='i'>Informed</option>
                                    </Form.Field>

                                </Grid.Column>
                                <Grid.Column width={7}>

                                    <Form.Field
                                        control='select'
                                        onChange={this.createRaciObject}
                                        name='assignment'
                                        id='assignment'>
                                        <option value='Select'>Select</option>
                                        {optionsArray && optionsArray.map((community) => {

                                            return <option value={JSON.stringify(community)} key={community.id}>{community.label}</option>

                                        })}
                                    </Form.Field>

                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Form.Field
                                        placeholder="Select User"
                                        name='user'
                                        id='user'
                                        required
                                        onChange={this.changeManager}
                                        control='select'
                                        style={{ width: "100%" }}
                                    >
                                        <option value='raci'>Select User</option>
                                        {this.props.RaciUserList && this.props.RaciUserList.data &&
                                            this.props.RaciUserList.data.map((user) => {
                                                return (
                                                    <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName}</option>
                                                );
                                            }, this)}
                                    </Form.Field>
                                </Grid.Column>
                                <Grid.Column style={{marginTop: "-10px"}} width={1}>
                                    <Button icon="plus" size="mini" type="submit" id="submit" disabled={this.state.isDisabled}></Button>
                                </Grid.Column>
                            </Form.Group> : "No Form" 
                        }
                    </Grid.Row>
                </Form>
            )

        }

        let deleteButton = (deleteAction, id) => {
            return (
                <Grid.Column width={1}>
                    <Button icon="trash alternate" className="trash-color" style={{ 'background': 'white', padding: "5px", margin: "4px 0 0 0" }} onClick={() => deleteAction(id)}></Button>
                </Grid.Column>
            )
        }
        return (

            <Grid className="practiceFlowResourcePane" >
                {initiativeData.status === 0 || initiativeData.status === 4 ? showForm() : null}

                {showA()}
                {this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.r &&
                    this.props.selectedActivityData.raci.r.map((r) => {
                        if (r.userList) {
                            let responsibleUser = r.userList.find(user => {
                                return user.accountUserId._id.toString() === r.accountUserId.toString()
                            })
                            return (
                                <Grid.Row key={r._id}>
                                    <Grid.Column width={3}>
                                        <div className="divBlock">
                                            <EllipsisTooltip name="Responsible" />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={7}>
                                        <div className="divBlock">
                                            {this.getMapping(r.communityId)}
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={5}>
                                        {!enableForm && responsibleUser ?
                                                <div className="divBlock">
                                                    {responsibleUser.accountUserId.firstName + ' ' + responsibleUser.accountUserId.lastName + ' '}
                                                    <span style={{marginLeft:"5px"}}>{'(' + responsibleUser.accountUserId.email + ')'}</span>
                                                </div>
                                                :
                                                <Form.Field
                                                    placeholder="Select User"
                                                    name='user'
                                                    id='user'
                                                    required
                                                    value={r.accountUserId}
                                                    onChange={(data) => {
                                                        for (const rObject of this.props.selectedActivityData.raci.r) { if (rObject && rObject.communityId === r.communityId) { rObject.accountUserId = data.target.value; rObject.changedMapping = true; rObject.changedAssignee = true; } }; this.forceUpdate(); dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                                                    }}
                                                    control='select'
                                                    className='users-list'
                                                >
                                                    {
                                                        r && r.userList ?
                                                            r.userList.map((user) => {
                                                                return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName} { '(' + user.accountUserId.email + ')'}</option>
                                                            }) :
                                                            this.props.RaciUserList && this.props.RaciUserList.data && !r.userList ?
                                                                this.props.RaciUserList.data.map((user) => {
                                                                    return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName} { '(' + user.accountUserId.email + ')'}</option>
                                                                }) :
                                                                <option value='raci'>Select User</option>
                                                    }
                                                </Form.Field>
                                        }

                                    </Grid.Column>
                                    {enableForm && this.props.selectedActivityData.raci.r.length > 1 ?
                                        deleteButton(this.deleteR, r) : ''}
                                </Grid.Row>
                            )

                        }
                    })
                }
                {this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.c &&
                    this.props.selectedActivityData.raci.c.map((c) => {
                        if (c.userList) {
                            let consultedUser = c.userList.find(user => {
                                return user.accountUserId._id.toString() === c.accountUserId.toString()
                            })
                            return (
                                <Grid.Row key={c._id}>
                                    <Grid.Column width={3}>
                                        <div className="divBlock">
                                            <EllipsisTooltip name="Consulted" />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={7}>
                                        <div className="divBlock">
                                            {this.getMapping(c.communityId)}
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={5}>
                                        {!enableForm && consultedUser ?
                                                <div className="divBlock">
                                                    {consultedUser.accountUserId.firstName + ' ' + consultedUser.accountUserId.lastName}
                                                </div>
                                                :
                                                <Form.Field
                                                    placeholder="Select User"
                                                    name='user'
                                                    id='user'
                                                    required
                                                    value={c.accountUserId}
                                                    onChange={(data) => {
                                                        for (const cObject of this.props.selectedActivityData.raci.c) { if (cObject && cObject.communityId === c.communityId) { cObject.accountUserId = data.target.value; cObject.changedMapping = true; cObject.changedAssignee = true; } }; this.forceUpdate(); dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                                                    }}
                                                    control='select'
                                                    className='users-list'
                                                >

                                                    {c && c.userList ?

                                                        c.userList.map((user) => {
                                                            return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName}</option>
                                                        }) :
                                                        this.props.RaciUserList && this.props.RaciUserList.data && !c.userList ?
                                                            this.props.RaciUserList.data.map((user) => {
                                                                return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName}</option>
                                                            }) :
                                                            <option value='raci'>Select User</option>
                                                    }
                                                </Form.Field>
                                        }

                                    </Grid.Column>
                                    {enableForm
                                        && deleteButton(this.deleteC, c)}
                                </Grid.Row>
                            )

                        }


                    })
                }
                {this.props.selectedActivityData.raci && this.props.selectedActivityData.raci.i &&
                    this.props.selectedActivityData.raci.i.map((i) => {

                        if (i.userList) {
                            let informedUser = i.userList.find(user => {
                                return user.accountUserId._id.toString() === i.accountUserId.toString()
                            })
                            return (
                                <Grid.Row key={i._id}>
                                    <Grid.Column width={3}>
                                        <div className="divBlock">
                                            <EllipsisTooltip name="Informed" />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={7}>
                                        <div className="divBlock">
                                            {this.getMapping(i.communityId)}
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={5}>
                                        {enableForm && informedUser ?
                                                <div className="divBlock">
                                                    {informedUser.accountUserId.firstName + ' ' + informedUser.accountUserId.lastName}
                                                </div>
                                                :
                                                <Form.Field
                                                    placeholder="Select User"
                                                    name='user'
                                                    id='user'
                                                    required
                                                    value={i.accountUserId}
                                                    onChange={(data) => {
                                                        for (const iObject of this.props.selectedActivityData.raci.i) { if (iObject && iObject.communityId === i.communityId) { iObject.accountUserId = data.target.value; iObject.changedMapping = true; iObject.changedAssignee = true; } }; this.forceUpdate(); dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData);
                                                    }}
                                                    control='select'
                                                    className='users-list'
                                                >
                                                    {
                                                        i && i.userList ?
                                                            i.userList.map((user) => {
                                                                return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName}</option>
                                                            }) :
                                                            this.props.RaciUserList && this.props.RaciUserList.data && !i.userList ?
                                                                this.props.RaciUserList.data.map((user) => {
                                                                    return <option value={user.accountUserId._id} key={user.accountUserId._id}>{user.accountUserId.firstName} {user.accountUserId.lastName}</option>
                                                                }) :
                                                                <option value='raci'>Select User</option>
                                                    }
                                                </Form.Field>
                                        }

                                    </Grid.Column>
                                    {enableForm
                                        && deleteButton(this.deleteI, i)}
                                </Grid.Row>
                            )

                        }


                    })
                }
            </Grid>

        )
    }
}

export default PracticeFlowResourcePaneForm